<template>
  <div
    class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
  >
    <div class="bg-white rounded shadow-lg w-[660px] h-fit flex flex-col">
      <button class="mb-[55px] self-end m-9" @click="closeModal">
        <span class="material-symbols-rounded text-grays-700 text-xl"
          >close</span
        >
      </button>
      <h2
        class="text-2xl text-center text-error flex items-center justify-center gap-2 mb-[55px] font-bold"
      >
        <span class="material-symbols-rounded text-error text-xl">error</span>
        אין לכם כרטיס אשראי שמור במערכת
      </h2>
      <h3
        class="self-center text-grays-800 text-base mb-[55px] w-[500px] text-center"
      >
        על מנת שתוכלו להזמין, עליכם להוסיף כרטיס אשראי לחשבון שלכם.
      </h3>

      <div
        class="border-t border-grays-300 flex flex-row-reverse px-8 mb-4 gap-2 items-end"
      >
        <button-primary class="mt-6 self-end" @click="goToPayments">
          <span class="material-symbols-rounded text-xl">add_card</span>
          הוספת כרטיס אשראי
        </button-primary>
        <button-text @click="closeModal"> ביטול </button-text>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import { mapActions } from "vuex";

export default {
  name: "NoCreditCardModal",
  components: { ButtonText, ButtonPrimary },
  methods: {
    ...mapActions({
      toggleModal: "noCreditCardModal/toggleIsModalVisible",
    }),
    closeModal() {
      this.toggleModal();
    },
    goToPayments() {
      this.toggleModal();
      this.$router.push("/payment-methods");
    },
  },
};
</script>

<style scoped>
</style>
